export default (function reverseNumbers(text) {
  return text.replace(/\d+(?:\.\d+)?/g, m => m.split('').reverse().join(''));
});